<script>
import { adrState, toggleMidiControl } from '@app/store/adrStore.svelte.js';
import { styleState } from '@app/store/styleStore.svelte.js';
import { fade } from 'svelte/transition';
import * as m from "@app/paraglide/messages.js";

function saveSettings(){
    /* Save settings to local storage */
    localStorage.setItem('cc-display-defaults', JSON.stringify({
        width: styleState.width,
        height: styleState.height,
        xPadding: styleState.xPadding,
        yPadding: styleState.yPadding,
        lineSpacing: styleState.lineSpacing,
        outlineColor: styleState.outlineColor,
        color: styleState.color,
        adrFontSize: styleState.adrFontSize
    }));
}
</script>

<div class="adr-container">
    <div class="adr-header">
        <h5>{m.options_adr_title()}</h5>
        <p class="text-muted mb-0">{m.options_adr_desc()}</p>
    </div>

    <div class="adr-card" transition:fade={{ duration: 150 }}>
        <div class="adr-card-header">
            <h6 class="fw-bold mb-0">{m.options_adr_midi_title()}</h6>
        </div>
        <div class="adr-card-content">
            <div class="form-check form-switch mb-3">
                <input 
                    id="midiEnabledCheck" 
                    type="checkbox" 
                    class="form-check-input" 
                    checked={adrState.enable} 
                    onchange={() => toggleMidiControl()} 
                    aria-labelledby="midiEnabledLabel"
                >
                <label 
                    id="midiEnabledLabel" 
                    class="form-check-label d-flex align-items-center gap-2" 
                    for="midiEnabledCheck"
                >
                    {m.options_adr_enable_midi()} 
                    <i class="bi bi-info-circle text-muted" title={m.options_adr_enable_midi_help()}></i>
                </label>
            </div>
            
            <div class="mb-3">
                <label class="form-label" for="bpmInput">{m.options_adr_tempo_bpm()}</label>
                <div class="input-group">
                    <input 
                        id="bpmInput" 
                        class="form-control" 
                        type="number" 
                        min="0" 
                        step="1" 
                        bind:value={adrState.bpm}
                    >
                    <span class="input-group-text">BPM</span>
                </div>
            </div>
            
            <div class="mb-3">
                <label for="midiInputDeviceSelect" class="form-label">{m.options_adr_input_device()}</label>
                <select class="form-select" id="midiInputDeviceSelect" bind:value={adrState.selectedInput}>
                    {#each adrState.inputDevices as inputDevice (inputDevice.id)}
                        <option value={inputDevice}>{inputDevice.id} | {inputDevice.name}</option>
                    {/each}
                </select>
            </div>
            
            <div class="mb-0">
                <label for="midiOutputDeviceSelect" class="form-label">{m.options_adr_output_device()}</label>
                <select class="form-select" id="midiOutputDeviceSelect" bind:value={adrState.selectedOutput}>
                    {#each adrState.outputDevices as outputDevice (outputDevice.id)}
                        <option value={outputDevice}>{outputDevice.id} | {outputDevice.name}</option>
                    {/each}
                </select>
            </div>
        </div>
    </div>
    
    <div class="adr-card" transition:fade={{ duration: 150 }}>
        <div class="adr-card-header">
            <h6 class="fw-bold mb-0">{m.options_adr_preview_title()}</h6>
        </div>
        <div class="adr-card-content">
            <div class="form-check form-switch mb-0">
                <input 
                    id="adrPreviewEnabledCheck" 
                    type="checkbox" 
                    class="form-check-input" 
                    bind:checked={styleState.adrPreview} 
                    onchange={() => saveSettings()}     
                    aria-labelledby="adrPreviewEnabledLabel"
                >
                <label 
                    id="adrPreviewEnabledLabel" 
                    class="form-check-label d-flex align-items-center gap-2" 
                    for="adrPreviewEnabledCheck"
                >
                    {m.options_adr_enable_preview()} 
                    <i class="bi bi-info-circle text-muted" title={m.options_adr_enable_preview_help()}></i>
                </label>
            </div>
            <!-- ADR Font Size Input (Number) -->
            <div class="mt-3">
                <label class="form-label" for="adrFontSizeInput">{m.options_adr_font_size()}</label>
                <div class="input-group">
                    <input 
                        id="adrFontSizeInput" 
                        class="form-control" 
                        type="number" 
                        min="8" 
                        step="1" 
                        bind:value={styleState.adrFontSize}
                        onchange={() => saveSettings()}                        
                    >
                    <span class="input-group-text">px</span>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .adr-container {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    .adr-header {
        margin-bottom: 0.5rem;
    }

    .adr-header h5 {
        margin-bottom: 0.25rem;
        font-weight: 600;
    }

    .adr-card {
        background-color: var(--bs-light);
        border-radius: 0.5rem;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    }

    .adr-card-header {
        padding: 1rem;
        border-bottom: 1px solid rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
    }

    .adr-card-content {
        padding: 1rem;
    }
</style>
